import buildQuery from 'odata-query';
import { IRequestConfig } from 'models/Axios';
import { IUserData, IUser } from 'models/User';
import Services from './index.service';

export default class BusService extends Services<IUserData, IUser> {
  /**
   * Method to get BUs
   */
  public get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: {}
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 100;
    const order = orderby ? `${orderby}` : undefined;
    const filterQuery = buildQuery({ filter });

    const config: IRequestConfig<IUser> = {
      url: `/business-units`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order,
        $filter: filterQuery.split('=')[1] || undefined,
      },
    };

    return this.httpRequest(config);
  };
}
